__webpack_require__.p = "/jwpwai/AdrianLewandowski21257/lab6ReactProd/build/";